import { React, Component } from 'react';

const MTextarea = (props) => {

    const {
        name,
        label,
        placeholder,
        readOnly,
        icon,
        onClick,
        value,
        required,
        rows
    } = props;

    return (
        <div className="mb-3">
            <label>{label}</label>
            <div className="input-group input-group-joined mb-4">
                {icon &&
                    <span className="input-group-text readonly">
                        {icon}
                    </span>
                }

                <textarea className='form-control' rows={rows} {...props} >
                </textarea>
            </div>
        </div>
    )

}
export default MTextarea;